export function WebBenefitCardSkeleton() {
  return (
    <div className="my-10 relative w-full hidden md:flex">
      <div className="w-full border rounded-lg bg-white relative overflow-hidden">
        {/* Title placeholder */}
        <div className="absolute right-0 -top-6">
          <div className="h-6 w-32 bg-gray-300 animate-pulse rounded-[4px]" />
        </div>

        {/* Left border strip */}
        <div className="absolute -top-5 -bottom-5 -left-3 w-[27%] border-[5px] rounded-[15px] bg-gray-200 animate-pulse" />

        {/* Rows */}
        {Array.from({ length: 4 }).map((_, i) => (
          <div key={i} className={`relative items-center w-full flex -ml-2 ${i !== 3 ? "border-b-2 border-[#0000001A]" : ""}`}>
            {/* Left section (icon + text) */}
            <div className="flex gap-3 text-sm md:text-base font-extrabold items-center p-5 w-[27%]">
              <div className="h-4 w-4 rounded-full bg-gray-300 animate-pulse" />
              <div className="h-4 w-24 bg-gray-300 animate-pulse rounded" />
              <div className="h-4 w-4 bg-gray-300 animate-pulse rounded" />
            </div>

            {/* Right section (value/content) */}
            <div className="w-[70%] p-5">
              <div className="h-4 w-48 bg-gray-300 animate-pulse rounded mb-2" />
              <div className="h-4 w-64 bg-gray-200 animate-pulse rounded" />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export function MobileBenefitCardSkeleton() {
  return (
    <div className="relative md:hidden mt-6 mb-10 rounded-[15px] flex w-full">
      <div className="w-full border-2 rounded-[10px] bg-white relative overflow-hidden">
        {/* Title placeholder */}
        <div className="absolute right-0 -top-5">
          <div className="h-6 w-28 bg-gray-300 animate-pulse rounded-[4px]" />
        </div>

        {/* Rows */}
        {Array.from({ length: 4 }).map((_, i) => (
          <div key={i} className="block w-full">
            {/* Header row */}
            <div className="flex gap-3 items-center w-full px-5 py-3 bg-gray-100">
              <div className="h-4 w-4 rounded-full bg-gray-300 animate-pulse" />
              <div className="h-4 w-24 bg-gray-300 animate-pulse rounded" />
              <div className="h-4 w-4 rounded bg-gray-300 animate-pulse" />
            </div>

            {/* Value/content row */}
            <div className="w-full px-5 py-3 text-sm">
              <div className="h-4 w-40 bg-gray-300 animate-pulse rounded mb-2" />
              <div className="h-4 w-64 bg-gray-200 animate-pulse rounded" />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
